module.exports = __webpack_public_path__ + "img/nepal.346d7cc2.svg";